import { Routes } from "@angular/router";

export const authRoutes: Routes = [
  {
    path: "",
    loadComponent: () => import("@pages/auth/components/login/login.component"),
  },
  {
    path: "olvido",
    loadComponent: () =>
      import("@pages/auth/components/olvide/olvide.component"),
  },
  {
    path: "verificar",
    loadComponent: () =>
      import("@pages/auth/components/verificar/verificar.component"),
  },
];
